import { render, staticRenderFns } from "./view_bottom.vue?vue&type=template&id=57304630&scoped=true&"
import script from "./view_bottom.vue?vue&type=script&lang=js&"
export * from "./view_bottom.vue?vue&type=script&lang=js&"
import style0 from "./view_bottom.vue?vue&type=style&index=0&id=57304630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57304630",
  null
  
)

export default component.exports